import { render, staticRenderFns } from "./BusinessContactCategoryEdit.vue?vue&type=template&id=023f3d4f"
import script from "./BusinessContactCategoryEdit.vue?vue&type=script&lang=js"
export * from "./BusinessContactCategoryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports